import { render, staticRenderFns } from "./CompanyDetailHori.vue?vue&type=template&id=caa8e90c"
import script from "./CompanyDetailHori.vue?vue&type=script&lang=js"
export * from "./CompanyDetailHori.vue?vue&type=script&lang=js"
import style0 from "./CompanyDetailHori.vue?vue&type=style&index=0&id=caa8e90c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports